<div class="userpage" *ngIf="('ControlUsuarios' | permissionFilter)  ||  ('ControlRoles' | permissionFilter)">
  <div class="container-component">
        <users-list class="user-list"></users-list>
    <!-- <app-users-filters *ngIf="isFilterVisible"></app-users-filters> -->
    <!-- <mat-card> -->
      <!-- <search [DataSource]="DataSource" (showFiltersCallback)="showFiltersCallback()" (filterCallback)="filterCallback($event)"></search> -->
      <!-- <table-list  [Columns]="Columns" [Actions]="Actions" [Data]="Data" [hasActions]="hasActions" ></table-list> -->      
    <!-- </mat-card> -->
    </div>
</div>
<div *ngIf="!('ControlUsuarios' | permissionFilter)  &&  !('ControlRoles' | permissionFilter)">
  <br><br><br><br>
  <h1 class="error">User not Authorized to enter this page</h1>
</div>